"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RactiveComponentPlugin_1 = require("auto-widget-framework/src/Plugin/RactiveComponent/RactiveComponentPlugin");
const Ractive = require("ractive");
const configs_1 = require("../../configs/configs");
const FieldValidationTypes_1 = require("auto-widget-framework/src/Enum/FieldValidationTypes");
const DateSegments_1 = require("../../Enum/DateSegments");
class QuestionnaireRenderComponent extends RactiveComponentPlugin_1.default {
    /**
     * @inheritDoc
     */
    getElementName() {
        return "questionnaire";
    }
    getDependentComponents() {
        return ['date_input_component'];
    }
    getComponent() {
        return Ractive.extend({
            template: this.definition.getTemplate(),
            isolated: true,
            data: () => {
                return {
                    VALIDATION_TYPES: FieldValidationTypes_1.FieldValidationTypes
                };
            },
            questionnaireCheckboxChange: function (checkboxOrRadio) {
                if (checkboxOrRadio.type === "checkbox") {
                    this.setCheckboxState(checkboxOrRadio);
                }
                else if (checkboxOrRadio.type === "radio") {
                    const checkboxes = this.findAll(`input[name="${checkboxOrRadio.name}"]`);
                    for (let i = 0; i < checkboxes.length; i++) {
                        this.setCheckboxState(checkboxes[i]);
                    }
                }
            },
            setCheckboxState: function (checkboxOrRadio) {
                let container = checkboxOrRadio;
                do {
                    container = container.parentNode;
                } while (container && !container.hasAttribute(configs_1.configs.elementIDs.QUESTIONNAIRE_CHECKBOX_CONTAINER));
                if (checkboxOrRadio.checked) {
                    container.classList.add("px-qestr-answer-selected");
                }
                else {
                    container.classList.remove("px-qestr-answer-selected");
                }
            },
            isAnswerSelected: function (answerType, question, answers) {
                if (answers) {
                    const questionAnswer = answers.getAnsweredQuestion(question.getId());
                    return questionAnswer.hasAnswer(answerType.getValue());
                }
                else {
                    return question.isDefaultAnswerOption(answerType);
                }
            },
            getAnswerDatePart: function (part, answer) {
                const value = answer.getValue();
                return value.split("-")[DateSegments_1.DateSegments[part]];
            }
        });
    }
}
exports.default = QuestionnaireRenderComponent;
